export const isBetween = (value: number, start: number, end: number): boolean => {
  return value >= start && value <= end;
};
